export default __webpack_public_path__ + "static/media/logo-rv-digital.ba9f4bf6.svg";